import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AuthService} from '@app/services/auth/auth.service';

@Component({
    selector: 'app-test-flags',
    imports: [CommonModule],
    templateUrl: './test-flags.component.html',
    styleUrls: ['./test-flags.component.scss']
})
export class TestFlagsComponent {

  constructor(
    public auth: AuthService,
  ) { }

}
